var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 4.5A2.5 2.5 0 0 1 11.5 7h-7a2.5 2.5 0 0 1 0-5h7A2.5 2.5 0 0 1 14 4.5zm-10.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zm-1.5 7A2.5 2.5 0 0 1 4.5 9h7a2.5 2.5 0 0 1 0 5h-7A2.5 2.5 0 0 1 2 11.5zm10.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIo);
export default ForwardRef;